var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeechBubbleMed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 344,
    height: 218,
    viewBox: "0 0 344 218",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5213_237409)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.622 174.509C312.836 159.831 341.013 134.361 342.717 104C345.603 52.5864 271.48 6.61642 177.16 1.32314C82.8391 -3.97015 4.03833 33.4177 1.15299 84.8312C-1.73235 136.245 72.3904 182.215 166.711 187.508C200.276 189.392 231.876 185.87 258.789 178.235L287.534 205.527L270.622 174.509Z",
    fill: "#FBFBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.717 104L343.216 104.028L342.717 104ZM270.622 174.509L270.458 174.037L269.901 174.231L270.183 174.748L270.622 174.509ZM177.16 1.32314L177.131 1.82235L177.16 1.32314ZM1.15299 84.8312L1.65221 84.8593L1.15299 84.8312ZM166.711 187.508L166.739 187.009L166.711 187.508ZM258.789 178.235L259.133 177.872L258.926 177.676L258.652 177.754L258.789 178.235ZM287.534 205.527L287.189 205.89L287.973 205.288L287.534 205.527ZM342.218 103.972C340.532 134.018 312.617 159.378 270.458 174.037L270.786 174.981C313.055 160.284 341.495 134.704 343.216 104.028L342.218 103.972ZM177.131 1.82235C224.225 4.46523 266.251 17.2625 296.127 35.7913C326.022 54.3316 343.646 78.5336 342.218 103.972L343.216 104.028C344.674 78.0527 326.68 53.563 296.654 34.9415C266.61 16.3087 224.415 3.47433 177.188 0.823923L177.131 1.82235ZM1.65221 84.8593C3.07981 59.421 23.3012 37.3428 55.0824 22.2639C86.8442 7.19417 130.038 -0.820529 177.131 1.82235L177.188 0.823923C129.96 -1.82648 86.5938 6.2061 54.6538 21.3604C22.7332 36.5054 2.11152 58.828 0.653777 84.8032L1.65221 84.8593ZM166.739 187.009C119.646 184.366 77.6195 171.569 47.7433 153.04C17.8487 134.5 0.224604 110.298 1.65221 84.8593L0.653777 84.8032C-0.803961 110.778 17.1907 135.268 47.2162 153.89C77.2601 172.522 119.456 185.357 166.683 188.007L166.739 187.009ZM258.652 177.754C231.798 185.373 200.254 188.89 166.739 187.009L166.683 188.007C200.299 189.894 231.955 186.368 258.925 178.716L258.652 177.754ZM258.444 178.598L287.189 205.89L287.878 205.164L259.133 177.872L258.444 178.598ZM287.973 205.288L271.061 174.27L270.183 174.748L287.095 205.766L287.973 205.288Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5213_237409",
    x: 0.571533,
    y: 0.32373,
    width: 342.727,
    height: 217.566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5213_237409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5213_237409",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubbleMed);
export default __webpack_public_path__ + "static/media/speechBubbleMed.bf2da13aeb695d61f34ec7cff30fb2ec.svg";
export { ForwardRef as ReactComponent };